import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { applyPlatformFavicon, isCustomerBrandedRoute } from '../lib/favicon';

/** Keeps DocTree favicon on platform pages; customer /docs and /embed pages manage their own. */
const FaviconManager = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    if (!isCustomerBrandedRoute(pathname)) {
      applyPlatformFavicon();
    }
  }, [pathname]);

  return null;
};

export default FaviconManager;
